module.exports = __webpack_public_path__ + "static/media/S-task09_adjMatrix.7bf60f59.png";